const viewAny = (permissions) => {
  return permissions.includes('read-settings')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-settings')
}

const update = (permissions) => {
  return hasPermission(permissions, 'update-settings')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-settings')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};